<template>
    <div>
        <b-row>
            <b-col lg="12">
                <b-card
                    header="Select Date Range &amp; Filters"
                    header-text-variant="white"
                    header-bg-variant="info"
                >
                    <b-form inline @submit.prevent="reloadData()" class="d-flex align-items-center">
                        <date-picker
                                class="mr-2 mb-1 f-1"
                                v-model="start_date"
                                placeholder="Start Date"
                                @input="refresh()"
                        />
                        <date-picker
                                class="mr-2 mb-1 f-1"
                                v-model="end_date"
                                placeholder="End Date"
                                @input="refresh()"
                        />
                        <b-form-select v-model="subject" class="mr-2 mb-1 f-1">
                            <option value="">All Subjects</option>
                            <option v-for="item in subjects" :value="item.subject" :key="item.id">{{ item.subject }}</option>
                        </b-form-select>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>

        <loading-card v-if="loading"></loading-card>

        <b-card v-else header="Support Call Logs"
                header-text-variant="white"
                header-bg-variant="info"
        >
            <div class="table-responsive">

                <b-table bordered striped hover show-empty
                    :items=" items "
                    :fields=" fields "
                    :current-page=" currentPage "
                    :per-page=" 0 "
                    :sort-by.sync=" sortBy "
                    :sort-desc.sync=" sortDesc "
                >

                    <template v-slot:cell(actions)="row">

                        <b-btn size="sm" :href="`/${controller}/support-calls/${row.item.id}/edit`" target="_blank">View</b-btn>
                    </template>
                    <template v-slot:cell(created_at)="row">
                        <utc-time
                            :time="row.item.created_at"
                            :role="this.role"
                        />
                    </template>
                </b-table>
            </div>

            <b-row>

                <b-col lg="6" >

                    <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                </b-col>
                <b-col lg="6" class="text-right">

                    {{ paginationText }}
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

    import FormatsDates from "../mixins/FormatsDates";
    import UsesRole from "../mixins/UsesRole";
    import PaginatedTable from "../mixins/PaginatedTable";

    export default {

        mixins: [ FormatsDates, UsesRole, PaginatedTable ],
        props: {

            userId: {

                type    : Number,
                default : 0
            },
            role : String
        },
        data() {

            return {

                // filters
                start_date   : moment().subtract(1, 'week').format('MM/DD/YYYY'),
                end_date     : moment().format('MM/DD/YYYY'),
                client_id    : '',
                caregiver_id : '',
                subject      : '',

                subjects : [],

                fields: [
                    {
                        key: 'callers',
                        label: 'Callers',
                        sortable: true,
                    },
                    {
                        key: 'subject',
                        label: 'Subject',
                        sortable: true,
                    },
                    {
                        key: 'created_at',
                        label: 'Call Date',
                        sortable: true,
                    },
                    {
                        key: 'office_user_name',
                        label: 'Admin Name',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                    }
                ]
            }
        },

        computed: {

            baseUrl(){ return `/${this.controller}/support-calls`; },
            appliedFilters(){ return `?start=${this.start_date}&end=${this.end_date}&user_id=${this.userId}`; }
        },

        methods: {

        }
    }
</script>
